export default {"src":"https://images-cdn-staging.curipod.com/d-4abb62d8/_next/static/media/wake_county_wcpss.dd36f474.svg","height":67,"width":250};